<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'book']" class="text-blue-600 mr-2" />
            Course Type Distribution
        </h2>
        <div v-if="hasData">
            <apexchart type="pie" height="300" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📚</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CourseTypeDistributionChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return this.data.map(item => item.course_count);
        },
        chartOptions() {
            const labels = this.data.map(item => this.formatCourseType(item.course_type));
            const colors = this.getCourseTypeColors(labels);

            return {
                labels: labels,
                colors: colors,
                legend: {
                    position: 'bottom',
                    formatter: (seriesName, opts) => {
                        const seriesIndex = opts.seriesIndex;
                        const value = this.chartSeries[seriesIndex];
                        return `${seriesName} - ${value}`;
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Courses`,
                    },
                },
                chart: {
                    type: 'pie',
                }
            };
        }
    },
    methods: {
        formatCourseType(type) {
            const typeMap = {
                'LEC': 'Lecture/Class/Theory',
                'OL': 'Lab',
                'CP': 'Clinical Practicum',
                'OTH': 'Other'
            };
            return typeMap[type] || type;
        },
        getCourseTypeColors(labels) {
            const colorMap = {
                'Lecture/Class/Theory': '#3498DB',
                'Lab': '#E74C3C',
                'Clinical Practicum': '#F39C12',
                'Other': '#95A5A6'
            };

            return labels.map(label => colorMap[label] || '#95A5A6');
        }
    }
};
</script>